import React from 'react';
import { Routes, Route } from 'react-router-dom';
import {Home} from './pages/Home';
import {Shop} from './pages/Shop';
import {Support} from './pages/Support';
import {About} from './pages/About';
import {Contact} from './pages/Contact';
import {Cart} from './pages/Cart';
import {Checkout} from './pages/Checkout';
import {Profile} from './pages/Profile';
import {Orders} from './pages/Orders';
import {Featured} from './pages/Featured';
import {Recommended} from './pages/Recommended';
import { Product } from './pages/Product';
import { Story } from './pages/Story';
import { SignUp } from './pages/Signup';
import { SignIn } from './pages/Login';

const AppRoutes = () => {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/shop/:id" element={<Product />} />
      <Route path="/support" element={<Support />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/story" element={<Story />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/featured" element={<Featured />} />
      <Route path="/recommended" element={<Recommended />} />
      {/* <Route path="/checkout" element={<Checkout />} /> */}

      {/* auth */}

      <Route path="/login" element={<SignIn route='/' />} />
      <Route path="/signup" element={<SignUp route='/' />} />

    </Routes>
  );
};

export default AppRoutes;